import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class InputSanitizerService {
    /**
     * Sanitize name fields (firstName, lastName)
     * - Block HTML injection characters: < > & " `
     * - Block newlines and control characters
     * - Allow letters, numbers, common punctuation
     */
    sanitizeName(name: string): string {
        if (!name) {
            return '';
        }

        // Remove only dangerous characters for HTML/XSS injection:
        const sanitized = name.replace(/[<>&"`\n\r\t\x00-\x1F\x7F]/g, '');

        return sanitized;
    }
}
